import { reducer as formReducer } from 'redux-form';
import { EDIT_MY_VIDEO_FORM } from 'pages/my-videos.page/edit.page';
import { ARRAY_POP, ARRAY_PUSH, CHANGE } from 'redux-form/es/actionTypes';

export const form = formReducer.plugin({
  [EDIT_MY_VIDEO_FORM]: (state, action) => {
    switch (action.type) {
      case CHANGE:
        return {
          ...state,
          submitSucceeded: false,
        };

      case ARRAY_PUSH:
        return {
          ...state,
          submitSucceeded: false,
        };

      case ARRAY_POP:
        return {
          ...state,
          submitSucceeded: false,
        };

      default:
        return state;
    }
  },
});
